import SelectMenu from "../controls/SelectMenu";
import { excludeAllOption } from "../../shared/filterUtils";

export default function FilterMultiSelectDropdown(props) {
  const { header, onChange, options, resetFilter, valueName, value } = props;
  const selectableOptions = excludeAllOption(options);

  return (
    <div className="p-4">
      <div className="flex items-center justify-between gap-3">
        <p className="text-sm font-semibold text-[#0F172A]">{header}</p>
        <button
          type="button"
          onClick={() => resetFilter()}
          className="text-xs font-semibold text-[#2563EB] hover:text-[#1D4ED8]"
        >
          Reset
        </button>
      </div>
      <div className="mt-2 min-w-0 w-full max-w-full">
        <SelectMenu
          name={valueName}
          options={selectableOptions}
          value={Array.isArray(value) ? value : []}
          onValueChange={(nextValue) => onChange(nextValue ?? [])}
          isMulti
          filter={selectableOptions.length > 8}
          placeholder="Select..."
          menuPortalTarget={
            typeof document !== "undefined" ? document.body : null
          }
        />
      </div>
    </div>
  );
}
